import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './stores/store'
import '@/plugins/fontawesome'
import StackdriverErrorReporterPlugin from '@/plugins/stackdriverErrorReporter'
import maskDirective from './utils/maskDirective'

Vue.config.productionTip = false
Vue.directive('mask', maskDirective)
Vue.use(new StackdriverErrorReporterPlugin())

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app')
